export async function createSearchIndexIfNeeded({ BACKEND_BASE, collectionName, dbName }) {
    const res = await fetch(`${BACKEND_BASE}/atlas/create-search-index`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ collectionName, dbName, indexName: 'vector_index' })
    });
  
    return res.json();
  }
  
  export async function deleteByFileId({ BACKEND_BASE, dbName, collectionName, fileId }) {
    const res = await fetch(`${BACKEND_BASE}/atlas/delete-by-fileid`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dbName, collectionName, fileId })
    });
  
    return res.json();
  }
  


// WEBPACK FOOTER //
// ./src/utils/backendService.js